/** Admin Deliveries page: why a row is cancelled, and what a filter hides. */
import { APP_TIME_ZONE } from "./istDate";

/** "31 Oct, 06:31 am" — a stored UTC timestamp on the store's clock. */
export function whenIST(iso) {
  const d = new Date(iso);
  if (!iso || Number.isNaN(d.getTime())) return "";
  return d.toLocaleString("en-IN", {
    timeZone: APP_TIME_ZONE, day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit",
  });
}

const CANCEL_REASONS = {
  subscription_cancelled_by_admin: "Subscription cancelled by admin",
  subscription_cancelled_by_customer: "Subscription cancelled by customer",
  subscription_cancelled: "Subscription cancelled",
  subscription_paused: "Subscription paused",
};

/** "Subscription cancelled by admin" for a stored cancel_reason; unknown
 *  reasons read as words ("out_of_stock" → "Out of stock"); none → "". */
export function cancelReasonLabel(reason) {
  if (!reason) return "";
  if (CANCEL_REASONS[reason]) return CANCEL_REASONS[reason];
  const words = String(reason).replace(/_/g, " ").trim();
  return words ? words[0].toUpperCase() + words.slice(1) : "";
}

/** One line for a cancelled row: reason and when (IST), or "" when the row
 *  is not cancelled or carries neither. */
export function cancelNote(d, formatWhen = whenIST) {
  if (!d || d.status !== "cancelled") return "";
  const reason = cancelReasonLabel(d.cancel_reason);
  const when = d.cancelled_at ? formatWhen(d.cancelled_at) : "";
  return [reason, when].filter(Boolean).join(" · ");
}

/** Statuses of the rows that pass every filter EXCEPT status, most common
 *  first: [["cancelled", 49], ["placed", 1]]. Explains an empty list such
 *  as "New route 3 + Confirmed: 0 of 166". */
export function statusBreakdown(rows) {
  const counts = {};
  (rows || []).forEach((d) => { counts[d.status] = (counts[d.status] || 0) + 1; });
  return Object.entries(counts).sort((a, b) => b[1] - a[1] || a[0].localeCompare(b[0]));
}
